export const LATEST_RELEASE_NOTES = `
<ul>
  <li><strong>Vite 8 & Rolldown:</strong> Hemos actualizado el motor de la aplicación a la última versión disponible, mejorando los tiempos de carga y la eficiencia del empaquetado.</li>
  <li><strong>TypeScript 6:</strong> Mejoras en la solidez del código gracias al nuevo sistema de tipos de TypeScript.</li>
  <li><strong>Optimización Multilingüe:</strong> Refinamiento en el sistema de carga de idiomas para una navegación más fluida.</li>
  <li><strong>Mantenimiento Trimestral:</strong> Actualización completa de todas las dependencias principales para garantizar la seguridad y el rendimiento a largo plazo.</li>
</ul>
`

